/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CardTypeList = {
    type: 'array',
    contains: {
        type: 'CardType',
    },
} as const;
